import { render, staticRenderFns } from "./ExpansionSettingsComponent.vue?vue&type=template&id=3a111e7c&scoped=true"
import script from "./ExpansionSettingsComponent.vue?vue&type=script&lang=js"
export * from "./ExpansionSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./ExpansionSettingsComponent.vue?vue&type=style&index=0&id=3a111e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a111e7c",
  null
  
)

export default component.exports